import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-miscsettings',
  templateUrl: './miscsettings.component.html',
  styleUrls: ['./miscsettings.component.css']
})
export class MiscsettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
